import React, { createContext, useContext, useState, useCallback } from "react";

const dict = {
  en: {
    "brand.tagline": "Luxury Catering · Crafted Moments",
    "nav.dashboard": "Dashboard",
    "nav.orders": "Orders",
    "nav.calendar": "Calendar",
    "nav.marketing": "Marketing",
    "nav.utensils": "Utensils",
    "nav.tasks": "My Tasks",
    "nav.taskmanager": "Task Manager",
    "nav.kitchen": "Kitchen Prep",
    "nav.staff": "Staff",
    "nav.reports": "Reports",
    "nav.settings": "Settings",
    "nav.portal": "My Events",
    "nav.plan": "HNC Customer Order",
    "nav.corporate": "Corporate Quotation",
    "nav.enquiries": "Enquiries",
    "nav.logistics": "Logistics",
    "nav.driver": "My Trips",
    "nav.menu": "Menu",
    "nav.inventory": "Inventory",
    "nav.purchasing": "Purchasing",
    "nav.warehouse": "Warehouse",
    "nav.communications": "Team Feed",
    "nav.cost": "Cost Control",
    "nav.users": "Users",
    "nav.signups": "Signup Queue",
    "nav.permissions": "Permissions",
    "nav.logout": "Sign out",
    "login.title": "Welcome Back",
    "login.subtitle": "Sign in to manage tonight's affair.",
    "login.email": "Email address",
    "login.password": "Password",
    "login.submit": "Sign In",
    "login.demo": "Demo accounts",
    "common.search": "Search",
    "common.create": "Create",
    "common.save": "Save",
    "common.cancel": "Cancel",
    "common.delete": "Delete",
    "common.edit": "Edit",
    "common.close": "Close",
    "common.balance": "Balance",
    "common.deposit": "Deposit Paid",
    "common.total": "Total",
    "common.pax": "pax",
    "common.status": "Status",
    "common.date": "Date",
    "common.upcoming": "Upcoming",
    "stage.order_confirmed": "Order Confirmed",
    "stage.kitchen_preparing": "Kitchen Preparing",
    "stage.driver_assigned": "Driver Assigned",
    "stage.on_the_way": "On The Way",
    "stage.setup_in_progress": "Setup In Progress",
    "stage.event_ready": "Event Ready",
    "stage.completed": "Completed",
  },
  zh: {
    "brand.tagline": "奢华宴会 · 精心呈献",
    "nav.dashboard": "仪表盘",
    "nav.orders": "订单",
    "nav.calendar": "日历",
    "nav.marketing": "营销策划",
    "nav.utensils": "餐具清单",
    "nav.tasks": "我的任务",
    "nav.taskmanager": "任务管理",
    "nav.kitchen": "厨房备料",
    "nav.staff": "员工",
    "nav.reports": "报表",
    "nav.settings": "设置",
    "nav.portal": "我的活动",
    "nav.plan": "HNC 顾客订单",
    "nav.corporate": "企业报价",
    "nav.enquiries": "询价请求",
    "nav.logistics": "物流",
    "nav.driver": "我的行程",
    "nav.menu": "菜单",
    "nav.inventory": "库存",
    "nav.purchasing": "采购",
    "nav.warehouse": "仓库",
    "nav.communications": "团队动态",
    "nav.users": "用户管理",
    "nav.signups": "申请审核",
    "nav.permissions": "权限",
    "nav.logout": "退出",
    "login.title": "欢迎回来",
    "login.subtitle": "登录以管理今夜的盛事。",
    "login.email": "电邮地址",
    "login.password": "密码",
    "login.submit": "登录",
    "login.demo": "示范帐户",
    "common.search": "搜索",
    "common.create": "新建",
    "common.save": "保存",
    "common.cancel": "取消",
    "common.delete": "删除",
    "common.edit": "编辑",
    "common.close": "关闭",
    "common.balance": "余额",
    "common.deposit": "已付订金",
    "common.total": "总额",
    "common.pax": "人",
    "common.status": "状态",
    "common.date": "日期",
    "common.upcoming": "即将到来",
    "stage.order_confirmed": "订单已确认",
    "stage.kitchen_preparing": "厨房备料中",
    "stage.driver_assigned": "已安排司机",
    "stage.on_the_way": "正在前往",
    "stage.setup_in_progress": "现场布置中",
    "stage.event_ready": "宴会就绪",
    "stage.completed": "已完成",
  },
};

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("hnc.lang") || "en");

  const t = useCallback((key, fallback) => {
    return dict[lang]?.[key] || dict.en[key] || fallback || key;
  }, [lang]);

  const change = (l) => { setLang(l); localStorage.setItem("hnc.lang", l); };

  return (
    <I18nContext.Provider value={{ lang, t, setLang: change }}>
      {children}
    </I18nContext.Provider>
  );
}

export const useI18n = () => useContext(I18nContext);
